module.exports = __webpack_public_path__ + "static/media/farming-equipments.e6be0de4.jpg";